import { addContactsValidation } from './contacts-validation'
import { addRegistrationFormValidation } from './registration-form-validation'
import { registerCaptchaFieldIfExists } from './captcha-field'

const behaviors = [addContactsValidation, addRegistrationFormValidation, registerCaptchaFieldIfExists]

export const registerBehaviors = submitArgs => behaviors.forEach(behavior => behavior(submitArgs))
